module.exports = __webpack_public_path__ + "img/edge_divers_allumer_eteindre.09efd79e.svg";